import React from 'react';
import { Avatar, Chip, Grid } from '@mui/material';

function DeploymentProgressChips({
  counts,
  pickUpSelected,
  dropOffSelected,
  vehicleMissingSelected,
  vehicleInaccessibleSelected,
  handleClick,
}) {
  if (!counts) return <div />;
  const {
    total,
    totalPickUp,
    totalDropOff,
    totalVehicleMissing,
    totalVehicleInaccessible,
  } = counts;
  return (
    <Grid container>
      <Grid item xs={3} />
      <Grid item xs={6}>
        <p>
          <strong>Summary Stats</strong>
        </p>
        <Chip
          color="primary"
          label="Total"
          key="Total"
          avatar={<Avatar>{total || 0}</Avatar>}
        />
        <Chip
          clickable
          avatar={totalPickUp ? <Avatar>{totalPickUp}</Avatar> : null}
          color="primary"
          key="pickUpSelected"
          label="Pick up"
          count={totalPickUp}
          selected={pickUpSelected}
          onClick={() => handleClick('filterPickUp')}
          variant={pickUpSelected ? 'default' : 'outlined'}
        />
        <Chip
          clickable
          avatar={totalDropOff ? <Avatar>{totalDropOff}</Avatar> : null}
          color="primary"
          key="dropOffSelected"
          label="Drop off"
          count={totalDropOff}
          selected={dropOffSelected}
          onClick={() => handleClick('filterDropOff')}
          variant={dropOffSelected ? 'default' : 'outlined'}
        />
        <Chip
          clickable
          avatar={totalVehicleMissing ? <Avatar>{totalVehicleMissing}</Avatar> : null}
          color="primary"
          key="vehicleMissingSelected"
          label="Vehicle missing"
          count={totalVehicleMissing}
          selected={vehicleMissingSelected}
          onClick={() => handleClick('filterVehicleMissing')}
          variant={vehicleMissingSelected ? 'default' : 'outlined'}
        />
        <Chip
          clickable
          avatar={totalVehicleInaccessible ? <Avatar>{totalVehicleInaccessible}</Avatar> : null}
          color="primary"
          key="vehicleInaccessibleSelected"
          label="Vehicle inaccessible"
          count={totalVehicleInaccessible}
          selected={vehicleInaccessibleSelected}
          onClick={() => handleClick('filterVehicleInaccessible')}
          variant={vehicleInaccessibleSelected ? 'default' : 'outlined'}
        />
      </Grid>
    </Grid>
  );
}

export default DeploymentProgressChips;
